module.exports = __webpack_public_path__ + "static/media/electronicHealthCard-min.e4e0fa3c.jpg";